import axios from "axios"
import baseUrl from "./base"

const paketApi = {
  fetchPaket: async (token) => {
    return await axios.get(`${baseUrl}/api/paket/get`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  fetchPaketPublic: async (token) => {
    return await axios.get(`${baseUrl}/api/paket/getPublic`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  searchPaketAndLayananPublic: async (data) => {
    return await axios.get(`${baseUrl}/api/searchPublic?query=${data.search}`)
  },
  showPaketPublic: async (slug) => {
    return await axios.get(`${baseUrl}/api/paket/${slug}/show`)
  },
  updatePaket: async (token, id, data) => {
    return await axios.post(`${baseUrl}/api/paket/${id}/update`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  }
}

export default paketApi